import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Icon, Tooltip } from 'antd';
import { silentModeSelector } from '../../store/selectors';
import { setSilentMode } from '../../store/actions';
import { BiVolumeFull, BiVolumeMute } from 'react-icons/bi';

const SilentModeSwitch = ({ className }) => {
  const dispatch = useDispatch();

  const silentMode = useSelector(silentModeSelector);

  const handleClick = () => {
    dispatch(setSilentMode(!silentMode));
  };

  return (
    <Tooltip
      title={
        silentMode ? 'Выключить беззвучный режим' : 'Включить беззвучный режим'
      }
      getPopupContainer={(trigger) => trigger.parentNode}
      placement='bottomRight'
    >
      <Button onClick={handleClick} className={className}>
        <Icon component={silentMode ? BiVolumeMute : BiVolumeFull} />
      </Button>
    </Tooltip>
  );
};

export default SilentModeSwitch;
